import { trackRequiredFieldFill } from './trackRequiredFieldFill';

const REQUIRED_PRICE_FIELDS = ['price', 'bargainTerms.price'];

export const trackRequiredFieldFillByName = (category: string, inputName: string) => {
  let label;

  if (REQUIRED_PRICE_FIELDS.includes(inputName)) {
    label = 'price';
  } else if (inputName === 'bargainTerms.deposit') {
    label = 'deposit';
  } else if (inputName === 'monthlyIncome') {
    label = 'monthly_revenue';
  } else {
    return;
  }

  trackRequiredFieldFill(category, label);
};
